'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var moment = require('moment');
var round = require('lodash/round');
var toString = require('lodash/toString');

var _require = require('../config'),
    returnProfiles = _require.returnProfiles,
    scaling = _require.scaling;

var constants = require('./constants');

var _require2 = require('./helpers'),
    cf = _require2.cf;

function plan(state) {
  if (!state.hasOwnProperty('scaling')) {
    state = _extends({}, state, {
      scaling: true
    });
  }

  var goalConstants = constants(state);

  var investmentPeriodEquity = state.customInvestmentPeriodEquity !== null ? state.customInvestmentPeriodEquity : returnProfiles[state.investmentPeriodReturn].equity;

  var spendingPeriodEquity = state.customSpendingPeriodEquity !== null ? state.customSpendingPeriodEquity : returnProfiles[state.spendingPeriodReturn].equity;

  var equity_percentage_no_scaling = [investmentPeriodEquity].concat(_toConsumableArray(Array((state.spendStartAge - state.age) * 12).fill(investmentPeriodEquity)), _toConsumableArray(Array((state.spendStopAge - state.spendStartAge) * 12).fill(spendingPeriodEquity)));

  var equity_percentage = state.scaling === true ? equity_percentage_no_scaling.map(function (i, idx) {
    return idx < 6 ? scaling[toString(i)]['m' + toString(idx)] : i;
  }) : equity_percentage_no_scaling;

  var target_return = [0].concat(_toConsumableArray(Array((state.spendStartAge - state.age) * 12).fill(goalConstants.investmentPeriodReturn)), _toConsumableArray(Array((state.spendStopAge - state.spendStartAge) * 12).fill(goalConstants.spendingPeriodReturn)));

  var expenditure = [0].concat(_toConsumableArray(Array((state.spendStartAge - state.age) * 12).fill(0)), _toConsumableArray(goalConstants.spendOutflows.reduce(function (i, j) {
    return [].concat(_toConsumableArray(i), [round(j, 2)], _toConsumableArray(Array(11).fill(0)));
  }, [])));

  var sip_amount = [state.startingAllocation].concat(_toConsumableArray(Array((state.investStartAge - state.age) * 12).fill(0)), _toConsumableArray(cf(goalConstants.regularInvestment, state.inflation, 0, state.investStopAge - state.investStartAge, 12).reduce(function (i, j) {
    return [].concat(_toConsumableArray(i), _toConsumableArray(Array(12).fill(round(j / 12, 2))));
  }, [])), _toConsumableArray(Array((state.spendStopAge - state.investStopAge) * 12).fill(0)));

  var goalPlan = equity_percentage.map(function (i, idx) {
    return {
      equity_percentage: i / 100,
      debt_percentage: (100 - i) / 100,
      target_return: target_return[idx],
      expenditure: expenditure[idx],
      sip_amount: sip_amount[idx]
    };
  });

  var today = moment().date();

  if (today < 21) {
    return goalPlan.reduce(function (i, j, idx) {
      return [].concat(_toConsumableArray(i), [_extends({}, j, {
        target_amount: idx === 0 ? sip_amount[idx] : round(i[idx - 1].target_amount * Math.pow(1 + i[idx - 1].target_return, 1 / 12) + j.sip_amount - j.expenditure, 2),
        as_on_date: idx === 0 ? moment().subtract(today - 1, 'days').format('YYYY-MM-DD') : moment(i[idx - 1].as_on_date, 'YYYY-MM-DD').add(1, 'months').format('YYYY-MM-DD')
      })]);
    }, []);
  }

  return [_extends({}, goalPlan[0], {
    as_on_date: moment().subtract(today - 1, 'days').format('YYYY-MM-DD'),
    target_amount: goalPlan[0].sip_amount
  })].concat(_toConsumableArray(goalPlan)).reduce(function (i, j, idx) {
    return [].concat(_toConsumableArray(i), [_extends({}, j, {
      target_amount: idx < 2 ? j.sip_amount : round(i[idx - 1].target_amount * Math.pow(1 + i[idx - 1].target_return, 1 / 12) + j.sip_amount - j.expenditure, 2),
      as_on_date: idx === 0 ? j.as_on_date : moment(i[idx - 1].as_on_date, 'YYYY-MM-DD').add(1, 'months').format('YYYY-MM-DD')
    })]);
  }, []);
}

//   return equity_percentage.map((i, idx) => ({
//     equity_percentage: (i/100),
//     debt_percentage: (100-i)/100,
//     target_return: target_return[idx],
//     expenditure: expenditure[idx],
//     sip_amount: sip_amount[idx],
//   })).reduce((i, j, idx) => [
//     ...i,
//     {
//       ...j,
//       target_amount: idx === 0 ? sip_amount[idx] :
//       round((i[idx-1].target_amount * ((1 + j.target_return) ** (1/12))) + j.sip_amount - j.expenditure, 2),
//       as_on_date: idx === 0 ? planStartDate() :
//       moment(i[idx-1].as_on_date, "YYYY-MM-DD").add(1, 'months').format('YYYY-MM-DD')
//     }
//   ], [])
// }

// const planStartDate = () => {
//   const today = moment().date()
//   return today < 21 ?
//     moment().subtract(today - 1, 'days').format('YYYY-MM-DD') :
//     moment().endOf('month').add(1, 'days').format('YYYY-MM-DD')
// }

module.exports = plan;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/lib/plan.js
// module id = 222
// module chunks = 0